import mktoForm from "./js/mkto/mktoForm.js";

window.__alpineModules = {
	...(window.__alpineModules || {}),
	mktoForm,
};
